import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlayersPaymentComponent } from './players-payment.component';

const routes: Routes = [
  {
    path: '',

    component: PlayersPaymentComponent,
    data: {
      title: 'Home'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlayersPaymentRoutingModule { }
